<template>
  <div class="rpt-result" ref="rpt-result">
    <loading :active.sync="isLoading" :can-cancel="false" :is-full-page="true" loader="bars">
      <template slot="after">
        <h3>系統分析中,請您等待...</h3>
      </template>
    </loading>
    <CRow>
      <CCol class="text-center" md="12">
        <!--<h3>零售業市場機會報告</h3>-->
        <h2 class="mt-2">
          <strong style=" color: #1a5611">#{{ adl5Info.adl2_namel }} {{ adl5Info.adl5_namel }}</strong> 
          <CButton id="downloadReport" style=" float: right" class="btn btn-downloadreport" @click="downloadReportScreen">
            <CIcon name="cil-cloud-download"/><strong class="p-1">下載報告</strong>
            <vue-fontawesome v-if="downloadLoading" icon="circle-o-notch" class="fa-spin"></vue-fontawesome>
          </CButton>          
          <div style=" float: left; font-size: 10px">
            {{ reportId }}
          </div>
        </h2>
        <div v-if="industryInfo !== undefined" class="row justify-content-md-center">
          <span
            class="col col-lg-2 badge mr-1"
            style=" 
margin-bottom: 0.5rem;
font-size: 16px;
background-color: #e4e4e4 !important;
color: #454545;
vertical-align: middle;
            "
          >
            <CIcon class="mr-2" name="cib-discover" style=" color: #9cbe40"/>{{ industryInfo.Name }}
          </span>
          <span
            class="col col-lg-2 badge mr-1"
            style=" 
margin-bottom: 0.5rem;
font-size: 16px;
background-color: #e4e4e4 !important;
color: #454545;
vertical-align: middle;
            "
          >
            <CIcon class="mr-2" name="cib-discover" style=" color: #90aee6"/>半徑{{ radiusLabel }}
          </span>
          <span
            class="col col-lg-2 badge mr-1"
            style=" 
margin-bottom: 0.5rem;
font-size: 16px;
background-color: #e4e4e4 !important;
color: #454545;
vertical-align: middle;
            "
          >
            <CIcon class="mr-2" name="cib-discover" style=" color: #ff6384"/>客單價{{ priceLabel }}
          </span>
        </div>
        <div id="mapResult" style=" height: 200px; width: 100%"></div>
        <br/>
      </CCol>
    </CRow>
    <CRow>
      <CCol md="12">
        <reportsummarysection ref="reportsummarysection"/>
      </CCol>
    </CRow>
    <CRow class="row-h350">
      <CCol md="6">
        <CCard id="ga-track-RecommendationScore">
          <CCardBody>
            <div class="DivInline">
              <div class="title">推薦指數</div>
              <div class="mt-1">
                <svg-img-icons
                  v-c-tooltip="
                  '<div class=text-left>依所在縣市之人口組成、人流吸引力、零售業密度以及同行業門店聚集度等各項因子，組成該地點之綜合指標。請注意，本指數未考慮自身品牌力與競爭強度之影響或任何租金成本等，推薦指數僅供開店參考。​<br/>依全台同零售產業中之分數按比例分段，最低25%、中間50%與最高25%，供參考。</div>'
                  "
                  height="20"
                  name="question"
                  width="22"
                />
              </div>
            </div>
            <gaugechart ref="gaugechart"/>
          </CCardBody>
        </CCard>
      </CCol>
      <CCol md="6">
        <CCard>
          <CCardBody style=" padding-bottom: 0px" id="ga-track-FoodDelivery">
            <div class="DivInline">
              <div class="title" style=" margin-bottom: 5px">餐飲外送指數</div>
              <div class="mt-1">
                <svg-img-icons
                  v-c-tooltip="
                  '<div class=text-left>依一般外送距離4km內之常駐人口數，60萬以上為100，60萬以下按比例給分</div>'
                  "
                  height="20"
                  name="question"
                  width="22"
                />
              </div>
            </div>
            <CRow class="b-block">
              <CCol><h5>附近人口外送潛力</h5></CCol>
              <CCol class="b-block-cont" :class=" { 'blur-style': lockedReport }">
                <p>
                  <span>{{ deliveryIndex }}<small class="text-muted">/100</small> </span>
                </p>
              </CCol>
            </CRow>
          </CCardBody>
          <CCardBody style=" padding-top: 50px" id="ga-track-Region">
            <div class="DivInline">
              <div class="title" style=" margin-bottom: 5px">地區資訊</div>
              <div class="mt-1">
                <svg-img-icons
                  v-c-tooltip="'<div class=text-left>輸入服務半徑內之設施與資訊</div>'"
                  height="20"
                  name="question"
                  width="22"
                />
              </div>
            </div>
            <CRow class="b-block">
              <CCol><h5>居住/工作人口比例</h5></CCol>
              <CCol class="b-block-cont" :class=" { 'blur-style': lockedReport }">
                <p>
                  <span>{{ allArea.ttl }}:{{ allArea.wrk }}</span>
                </p>
              </CCol>
            </CRow>
            <CRow class="b-block">
              <CCol><h5>本區平均店租約</h5></CCol>
              <CCol class="b-block-cont" :class=" { 'blur-style': lockedReport }">
                <p>
                  <span>{{ rentAverage }} 元/坪</span>
                </p>
              </CCol>
            </CRow>
            <CRow class="b-block mb-5">
              <CCol><h5>本區機能概況</h5></CCol>
              <div class="ml-1 preety-checkbox-group">
                <div class="mt-1 col-md-12" :class=" { 'blur-style': lockedReport }">
                  <CCol>
                    <input id="fov1" v-model="funcOverviewCheckedlist" disabled type="checkbox" value="school"/>
                    <label for="fov1">學校</label>
                  </CCol>
                  <CCol>
                    <input id="fov3" v-model="funcOverviewCheckedlist" disabled type="checkbox" value="hospital"/>
                    <label for="fov3">醫院</label>
                  </CCol>
                  <CCol>
                    <input id="fov4" v-model="funcOverviewCheckedlist" disabled type="checkbox" value="bus"/>
                    <label for="fov4">公車站</label>
                  </CCol>

                  <CCol>
                    <input id="fov2" v-model="funcOverviewCheckedlist" disabled type="checkbox" value="mrt"/>
                    <label for="fov2">捷運出入口</label>
                  </CCol>
                  <CCol>
                    <input id="fov5" v-model="funcOverviewCheckedlist" disabled type="checkbox" value="industrial"/>
                    <label for="fov5">工業區</label>
                  </CCol>
                  <CCol>
                    <input id="fov6" v-model="funcOverviewCheckedlist" disabled type="checkbox" value="supermarket"/>
                    <label for="fov6">連鎖超市</label>
                  </CCol>

                  <CCol>
                    <input id="fov7" v-model="funcOverviewCheckedlist" disabled type="checkbox" value="market"/>
                    <label for="fov7">傳統市場</label>
                  </CCol>
                  <CCol>
                    <input id="fov8" v-model="funcOverviewCheckedlist" disabled type="checkbox" value="shopping"/>
                    <label for="fov8">購物中心\量販店</label>
                  </CCol>
                  <CCol></CCol>
                </div>
              </div>
            </CRow>
          </CCardBody>
        </CCard>
      </CCol>
    </CRow>
    <!--人口資訊 及興趣點 setion-->
    <CRow>
      <CCol md="6">
        <CCard id="ga-track-Consumer">
          <CCardBody>
            <div class="title">消費者組成</div>
            <consumersection ref="consumersection"/>
          </CCardBody>
        </CCard>
      </CCol>
      <CCol md="6">
        <CCard id="ga-track-Age">
          <CCardBody>
            <div class="title">年齡組成</div>
            <agesection ref="agesection"/>
          </CCardBody>
        </CCard>
      </CCol>
    </CRow>
    <CRow>
      <CCol md="6">
        <CCard id="ga-track-Poi">
          <CCardBody>
            <div class="DivInline">
              <div class="title">周遭{{ businessRegistrationPoiChartTypeTitle }}數據</div>
              <div class="mt-1">
                <svg-img-icons
                  v-c-tooltip="'<div class=text-left>此服務範圍內之各類型產業數量</div>'"
                  height="20"
                  name="question"
                  width="22"
                />
              </div>
            </div>
            <businessRegistrationPoiChart
              ref="businessRegistrationPoiChart"
              @updateParentPoiChartTitle="updatePoiChartTitle"
            />
          </CCardBody>
        </CCard>
      </CCol>
      <CCol md="6">
        <CCard id="ga-track-Brands">
          <CCardBody>
            <div class="DivInline">
              <div class="title">指標品牌</div>
              <div class="mt-1">
                <svg-img-icons
                  v-c-tooltip="'<div class=text-left>此服務範圍內同產業之知名品牌門店數量</div>'"
                  height="20"
                  name="question"
                  width="22"
                />
              </div>
            </div>
            <brandstoresection ref="brandstoresection"/>
          </CCardBody>
        </CCard>
      </CCol>
    </CRow>

    <CRow v-if="showCVSAndTraffic">
      <CCol md="6">
        <conveniencestoresection ref="conveniencestoresection"/>
      </CCol>
      <CCol md="6">
        <traffic ref="trafficsection"/>
      </CCol>
    </CRow>
    <CRow>
      <CCol md="6">
        <consumptionsection ref="consumptionsection"/>
      </CCol>
      <CCol md="6">
        <comprehensiveIndicatorssection ref="comprehensiveIndicatorssection"/>
      </CCol>
    </CRow>

    <CRow>
      <CCol md="12">
        <CButton v-if="showSurveyButton" class="btn btn-success btn-block  mb-4" size="lg" @click="openSurvey">填問卷，送兌換碼乙張</CButton> 
      </CCol>  
    </CRow>

    <CModal :show.sync="showReportErrorModal" color="danger" title="Error">
      <h5 class="text-center">
        <CIcon customClasses="custom-icon-dange-w50p" name="cil-x-circle"></CIcon>
        <br/>{{ errorMessage }}
      </h5>
      <template #footer>
        <CButton color="danger" @click="closeMessageDialog">關閉</CButton>
      </template>
    </CModal>

    <CModal :show.sync="showErrorModal" color="danger" title="Error">
      <h5 class="text-center">
        <CIcon customClasses="custom-icon-dange-w50p" name="cil-x-circle"></CIcon>
        <br/>無此報告
      </h5>
      <template #footer>
        <CButton
          color="danger"
          @click="
          showErrorModal = false;
          gotoListPage();
          "
        >
          關閉
        </CButton>
      </template>
    </CModal>
  </div>
</template>

<script>
import axios from "axios";
// import * as firebase from "firebase";
import gaugechart from "../../components/_MarketReportResult_gaugechart.vue";
import consumersection from "../../components/_MarketReportResult_consumer.vue";
import agesection from "../../components/_MarketReportResult_age.vue";
//import retailsection from '../../components/_MarketReportResult_retail.vue';
import consumptionsection from "../../components/_MarketReportResult_consumption.vue";
import conveniencestoresection from "../../components/_MarketReportResult_conveniencestore.vue";
import brandstoresection from "../../components/_MarketReportResult_brandSotre.vue";
import businessRegistrationPoiChart from "../../components/_MarketReportResult_BusinessRegistrationPoiChart.vue";
import comprehensiveIndicatorssection from "../../components/_MarketReportResult_comprehensiveIndicators.vue";
import traffic from "../../components/_MarketReportResult_traffic.vue";
import reportsummarysection from "../../components/_MarketReportResult_analysisSummary.vue";
import freeAccountMask from "../../components/_MarketReportResult_freeAccountMask.vue";

import mapfunction from "../../util/mapfunction";

import appSettings from "../../util/settings";
import store from "../../util/store.js";
import Loading from "vue-loading-overlay";
import "vue-loading-overlay/dist/vue-loading.css";
import mobile from "../../util/mobile";
import { mapState } from "vuex";
const PRICE_LIST = appSettings.DropDownList.PriceList;
const RADIUS_LIST = appSettings.DropDownList.RadiusList;

export default {
  name: "report",
  components: {
    gaugechart,
    consumersection,
    agesection,
    //retailsection,
    consumptionsection,
    conveniencestoresection,
    brandstoresection,
    businessRegistrationPoiChart,
    comprehensiveIndicatorssection,
    traffic,
    reportsummarysection,
    Loading,
    freeAccountMask,
  },
  data() {
    return {
      adl5Info: {},
      allArea: {},
      industry: undefined,
      radius: undefined,
      price: undefined,
      industryInfo: undefined,
      priceLabel: "",
      radiusLabel: "",
      rentAverage: undefined,
      deliveryIndex: undefined,
      isLoading: false,
      x: 0,
      y: 0,
      map: undefined,
      showReportErrorModal: false,
      errorMessage: "",
      showErrorModal: false,
      funcOverviewCheckedlist: [],
      reportId: undefined,
      businessRegistrationPoiChartTypeTitle: "",
      showCVSAndTraffic: true,
      downloadLoading: false,
    };
  },
  computed: {
    ...mapState({
      lockedReport: (state) => state.lockedReport,
    }),
    showSurveyButton() { 
      return window.location.href.includes("qabeta.getchee.com");
    }
  },
  created() {},
  mounted() {
    this.isLoading = true;

    let params = this.$route.params;
    // console.log(`params`, params);
    let action = params.action;
    //use url query params when refresh page
    let query = this.$route.query;

    if (action === "showReport" || (query !== undefined && query.action === "showReport")) {
      let id = query !== undefined ? query.id : params.id;
      axios
        .post(appSettings.GetOldReports, {
          id: id,
          idToken: store.state.token,
        })
        .then(this.showReport)
        .catch(function (error) {
          console.log(error);
        });
    } else if (action === "showSampleReport" || (query !== undefined && query.action === "showSampleReport")) {
      axios
        .post(appSettings.GetSampleReport, {
          idToken: store.state.token,
        })
        .then(this.showSampleReport)
        .catch(function (error) {
          console.log(error);
        });
    } else if (action === "showLockedReport") {
      this.radius = params.radius;
      this.x = params.x;
      this.y = params.y;
      this.createMap(this.x, this.y);
      this.getParmsByLockReport();
    } else {
      if(window.sessionStorage.getItem("reportId") !== null) {
        axios
          .post(appSettings.GetOldReports, {
            id: window.sessionStorage.getItem("reportId"),
            idToken: store.state.token,
          })
          .then(this.showReport)
          .catch(function (error) {
            console.log(error);
          });
      }
      else {
        this.radius = params.radius;
        this.x = params.x;
        this.y = params.y;
        this.createMap(this.x, this.y);
        this.getParams();
      }
    }
  },
  methods: {
    closeMessageDialog() {
      this.showReportErrorModal = false;
      this.$router.push({
        name: "MarketReport",
        params: {},
      });
    },
    createMap(x, y) {
      var bingMapsKey = "";
      var mapBoxKey = "";

      var mapFactory = mapfunction.createMapFactory(bingMapsKey, mapBoxKey);

      var map = mapFactory.createMap("mapResult", "", {
        zoomTipLabel: {
          zoomInTipLabel: "ZoomIn",
          zoomOutTipLabel: "ZoomOut"
        },
        zoomValue: {
          default: 12,
          minZoom: 1,
          maxZoom: 20,
        },
        center: [x, y],
      });

      map.setBaseMap(mapfunction.MapStyle.GoogleMapRoad, false, "OverviewMap");
      map.createScaleLine();
      map.setZoom(18);

      map.createPoint("pp", x, y, "#ff143f");

      this.map = map;

      this.detectElementResize();
    },
    getParams() {
      var params = this.$route.params;
      var marketReportResult = this.marketReportResult;

      this.price = params.price;
      this.radius = params.radius;
      axios
        .post(appSettings.MarketReport, {
          idToken: store.state.token,
          x: params.x,
          y: params.y,
          industry: params.industry,
          radius: params.radius.value,
          price: params.price.value,
          useItemType: params.useItemType,
          useItemCode: params.useItemCode,
        })
        .then(marketReportResult)
        .catch(function (error) {
          console.log(error);
        })
        .finally(() => {
          this.isLoading = false;
          this.map.animatePoint(this.x, this.y);
        });
    },
    getParmsByLockReport() {
      var params = this.$route.params;
      // var marketReportResult = this.marketReportResult;
      //console.log(params);
      this.price = params.price;
      this.radius = params.radius;
      axios
        .post(appSettings.MarkLockedReport, {
          idToken: store.state.token,
          x: params.x,
          y: params.y,
          industry: params.industry,
          radius: params.radius.value,
          price: params.price.value,
        })
        .then((res) => {
          this.marketReportResult(res);
          const reportId = res.data.ReportId;
          window.sessionStorage.setItem("reportId", reportId);
        })
        .catch(function (error) {
          console.log(error);
        })
        .finally(() => {
          this.isLoading = false;
          this.map.animatePoint(this.x, this.y);
        });
    },
    gotoListPage() {
      this.$router.replace({ name: "MyReportList" });
    },
    gotoSurverycake() {
      //console.log(appSettings.MySurveycake)
      window.open(appSettings.MySurveycake, "_blank");
    },
    marketReportResult(response) {
      //console.log(response);
      var data = response.data;
      //console.log(data);
      if (!data.IsLogin) {
        store.commit("clearUser");
        this.$router.replace({ name: "Login" });
      } else {
        var result = data.Result;
        var resultSummaryObj = data.ResultSummary;

        //console.log(result);
        //console.log(resultSummary);

        this.reportId = data.ReportId;
        window.sessionStorage.setItem("reportId", this.reportId);
        
        let _price = PRICE_LIST.find((x) => x.value === parseInt(this.price.value));
        this.priceLabel = _price !== undefined ? _price.label : "";
        let _radius = RADIUS_LIST.find((x) => x.value === this.radius.value);
        this.radiusLabel = _radius !== undefined ? _radius.label : "";
        this.industryInfo = result.IndustryInfo;
        this.setLockedReport(data.LockedReport);

        if (result === undefined) {
          this.errorMessage = data.Message;
          this.showReportErrorModal = true;
        } else {
          var version = result.Version === undefined ? "1.0" : result.Version;

          this.adl5Info.adl2_namel = result.Adl2NameLocal;
          this.adl5Info.adl5_namel = result.Adl5NameLocal;

          this.industry = result.Industry;

          this.allArea.ttl = result.ResTtlPercent;
          this.allArea.wrk = result.WrkTtlPercent;

          this.rentAverage = result.RentAverageString == "N/A" ? "--" : result.RentAverageString;
          this.deliveryIndex = result.DeliveryIndex;

          //version 2.0--------------------------------------------------start
          if (version == "2.0") {
            var primarySchool_ttl = result.StudentCount.PrimarySchool;
            var highSchool_ttl = result.StudentCount.HighSchool;
            var university_ttl = result.StudentCount.University;

            //本區機能概況new
            this.funcOverviewCheckedlist = result.FuncOverviewCheckedList;

            //指標品牌new
            var brandDoorCount = result.PoiCount;
            this.$refs.brandstoresection.setData(brandDoorCount);

            //超商指標
            if (result.CvsData !== undefined) {
              var csvData = result.CvsData;
              var conveniencestoresectionData = {
                doors_7_11: csvData.SevenElevenCount,
                doors_family: csvData.FamilyMartCount,
                doors_hiLif: csvData.HiLifeMartCount,
                doors_ok: csvData.OkMartCount,
              };
              this.$refs.conveniencestoresection.setData(conveniencestoresectionData);
            } else {
              this.showCVSAndTraffic = false;
            }

            //交通資訊
            if (result.TrafficInfo !== undefined) {
              var trafficInfo = result.TrafficInfo;
              this.$refs.trafficsection.setData(trafficInfo);
            } else {
              this.showCVSAndTraffic = false;
            }

            //周遭餐飲數據new
            var businessRegistrationPoi = result.BusinessRegistrationPoi;
            var businessRegistrationPoiByClassType =
              result.BusinessRegistrationPoiByClassType === undefined
              ? undefined
              : result.BusinessRegistrationPoiByClassType;
            this.$refs.businessRegistrationPoiChart.updateChart(
              businessRegistrationPoi,
              businessRegistrationPoiByClassType,
              result.IndustryInfo
            );
            let feature = this.map.createShapeByWKT("buffer", result.WellKnowTextBuffer);
            this.map.drawFeature(feature, "#3377ff");
            this.map.fitFeature(feature);
          }
          //version 2.0--------------------------------------------------end

          //消費者組成
          var consumersectionData = {
            avgfootfall: result.FootfallString,
            res_ttl: result.ResTtlString,
            wrk_ttl: result.WrkTtlString,
            hh_ttl: result.HHTtlString,
            primarySchool_ttl: primarySchool_ttl,
            highSchool_ttl: highSchool_ttl,
            university_ttl: university_ttl,
          };
          this.$refs.consumersection.setData(consumersectionData);

          //性名年齡
          var agesectionData = {
            male_female_ratio: result.ResMale + ":" + result.ResFemale,
            top_Age_groups: result.MaxRage + "歲",
          };

          this.$refs.agesection.setData(agesectionData, [
            result.Rage0014,
            result.Rage1524,
            result.Rage2534,
            result.Rage3544,
            result.Rage4554,
            result.Rage5564,
            result.Rage65Up,
          ]);

          //總消費力
          var consumptionsectionData = {
            avg_invoices_serviceArea: this.formattedTc(result.Mab2CTc, false),
            avg_amont_serviceArea: this.formattedTa(result.MabAmountAverage),
            avg_invoices_all: this.formattedTc(result.BaseMab2CTc, false),
            avg_amont_all: this.formattedTa(result.BaseMabAmountAverage),
            avg_invoices_percent:
              result.BaseMab2CTc != 0 ? Math.round((result.Mab2CTc / result.BaseMab2CTc) * 1000) / 10 : 0,
            original_avg_invoices_serviceArea: result.Mab2CTc,
            original_avg_amont_serviceArea: result.MabAmountAverage,
            original_avg_invoices_all: result.BaseMab2CTc,
            original_avg_amont_all: result.BaseMabAmountAverage,
          };

          //By分類消費力
          if (result.Mab2cByType != undefined && result.BaseMab2cByType != undefined) {
            var consumptionsectionByTypeData = result.Mab2cByType.map((item) => ({
              type: item.Type,
              original_avg_invoices_serviceArea: item.Mab2CDetail.Mab2CTc,
              avg_invoices_serviceArea: this.formattedTc(item.Mab2CDetail.Mab2CTc, false),
              original_avg_invoices_percent: item.Mab2CDetail.Percent,
              avg_invoices_percent: this.formattedTcPercent(item.Mab2CDetail.Percent),
              original_avg_amont_serviceArea: item.Mab2CDetail.MabAmountAverage,
              avg_amont_serviceArea: this.formattedTa(item.Mab2CDetail.MabAmountAverage),
            }));

            var consumptionsectionByTypeData_all = result.BaseMab2cByType.map((item) => ({
              type: item.Type,
              original_avg_invoices_all: item.Mab2CDetail.Mab2CTc,
              avg_invoices_all: this.formattedTc(item.Mab2CDetail.Mab2CTc, true),
              original_avg_amont_all: item.Mab2CDetail.MabAmountAverage,
              avg_amont_all: this.formattedTa(item.Mab2CDetail.MabAmountAverage),
            }));

            this.$refs.consumptionsection.setDataByType(
              consumptionsectionData,
              consumptionsectionByTypeData,
              consumptionsectionByTypeData_all
            );
          } else {
            //未分類消費力
            this.$refs.consumptionsection.setData(consumptionsectionData);
          }

          //商圈綜合指標new
          var comprehensiveIndicators = result.ComprehensiveIndicators;
          this.$refs.comprehensiveIndicatorssection.setData(comprehensiveIndicators);

          //推薦指數
          this.$refs.gaugechart.updateData(result.Score, result.ScoreDistribution, this.adl5Info);
          //this.$refs.gaugechart.setTotalScore(result.Score);

          //202505 報告分析總結
          let islock = data.LockedReport === true ? true : false;
          this.$refs.reportsummarysection.setData(
            this.reportId,
            islock,
            result.IsResultSummarySupported,
            resultSummaryObj
          );
        }
      }
    },
    showHistoryReport(data) {
      let result = data.Result;
      this.x = result.X;
      this.y = result.Y;
      this.industry = result.Industry; //industry objectid
      // this.radius = result.Radius;
      // this.price = result.Price;
      this.price = PRICE_LIST.find((x) => x.value === parseInt(result.Price));
      this.radius = RADIUS_LIST.find((x) => x.value === parseInt(result.Radius));
      
      //result.Price

      let jsonString = '{"data": { "ReportId":' + data.ReportId + ', "IsLogin": true, "Result":' + result.Result + "}}";
      //console.log(jsonString);

      const dataJson = JSON.parse(jsonString);
      dataJson.data.ResultSummary = {};
      if (result.ResultSummary) {
        var resultSummaryObj = JSON.parse(result.ResultSummary);
        Object.assign(dataJson.data.ResultSummary, resultSummaryObj);
      }
      dataJson.data.LockedReport = data.Result.LockedReport ?? false;

      this.createMap(this.x, this.y);
      // console.log(dataJson);
      this.marketReportResult(dataJson);
      this.isLoading = false;
      this.map.animatePoint(this.x, this.y);
    },
    showReport(response) {
      let data = response.data;
      if (!data.IsLogin) {
        store.commit("clearUser");
        this.$router.replace({ name: "Login" });
      } else if (data.Result === undefined) {
        this.isLoading = false;
        this.showErrorModal = true;
      } else {
        this.showHistoryReport(data);
      }
    },
    showSampleReport(response) {
      var data = response.data;
      //console.log(data);
      if (!data.IsLogin) {
        store.commit("clearUser");
        this.$router.replace({ name: "Login" });
      } else {
        if (data.Result == undefined) {
          this.isLoading = false;
          this.showErrorModal = true;
        } else {
          this.showHistoryReport(data);
        }
      }
    },
    updatePoiChartTitle(chartType) {
      this.businessRegistrationPoiChartTypeTitle = chartType === "All" ? "產業" : chartType;
    },
    formattedTa(value) {
      return value.toLocaleString("en") + "元";
    },
    formattedTc(value, isInWanUnit) {
      if (isInWanUnit) {
        return value + "萬張";
      }

      if (value < 10000) {
        return value + "張";
      } else {
        return Math.round(value / 1000.0) / 10 + "萬張";
      }
    },
    formattedTcPercent(value) {
      return Math.round(value * 1000) / 10 + "%";
    },
    isMobile: function () {
      return mobile.isMobile();
    },
    async downloadReportScreen() {
      this.downloadLoading = true;
      //取得現在container
      const container = document.querySelector(".c-app");
      let container_width = container.clientWidth;
      let container_height = container.clientHeight;

      const screenHtmlContent = this.getScreenHtmlContent(container_width, container_height);

      // 將 HTML 內容轉為 Blob
      const blob = new Blob([screenHtmlContent], { type: "text/html" });
      const file = new File([blob], "screenshot.html", { type: "text/html" });

      //const link = document.createElement("a");
      //link.href = URL.createObjectURL(blob);
      //link.download = "screenshot.html";
      //link.click();

      const formData = new FormData();
      formData.append("screenHtmlFiles", file);
      formData.append("baseUrl", window.location.origin);
      formData.append("width", container_width);
      formData.append("height", container_height);

      try {
        const response = await axios.post(appSettings.DownloadReportPDF, formData, {
          headers: {
            "Content-Type": "multipart/form-data",
          },
          responseType: "blob",
        });

        // 處理下載
        if (response.status === 200) {
          const blob = new Blob([response.data], {
            type: response.headers["content-type"],
          });
          const url = window.URL.createObjectURL(blob);
          const link = document.createElement("a");
          link.href = url;

          let filename = "downloaded_file";
          const contentDisposition = response.headers["content-disposition"];
          let filenameMatch;

          if (contentDisposition) {
            filenameMatch = contentDisposition.match(/filename[^;=\n]*=((['"]).*?\2|[^;\n]*)/);
            if (filenameMatch && filenameMatch[1]) {
              filename = decodeURIComponent(filenameMatch[1].replace(/['"]/g, ""));
            }
          }

          if (!contentDisposition || !filenameMatch) {
            const contentType = response.headers["content-type"]?.toLowerCase();
            if (contentType) {
              const today = new Date().toISOString().slice(0, 10).replace(/-/g, "");
              if (contentType.includes("pdf")) filename = `${today}_好店緣商圈數據報告.pdf`;
              //else if (contentType.includes("png")) filename = "Screenshot.png";
              //else if (contentType.includes("jpeg")) filename = "Screenshot.jpg";
              //else filename = "Screenshot.bin"; // fallback
            }
          }

          if (window.navigator && window.navigator.msSaveOrOpenBlob) {
            window.navigator.msSaveOrOpenBlob(blob, filename);
          } else {
            const url = window.URL.createObjectURL(blob);
            const link = document.createElement("a");
            link.href = url;
            link.setAttribute("download", filename);
            document.body.appendChild(link);
            link.click();
            document.body.removeChild(link);
            window.URL.revokeObjectURL(url);
          }
        }
      } catch (error) {
        console.error("API 錯誤:", error);
      } finally {
        this.downloadLoading = false;
      }
    },
    getScreenHtmlContent(container_width, container_height) {
      //1.處理地圖的canvas,因為ol-viewport不止一張畫布要先合併再轉換為圖片
      const mapCanvas = this.map.getViewport().querySelectorAll("canvas");
      const mapImg = this.mergeMapCanvasAndConvertToImg(mapCanvas, container_width);

      //處理非地圖畫布，轉換為圖片
      const canvases = document.querySelectorAll("canvas:not(.ol-layer canvas)");
      const otherImages = [];
      for (const canvas of canvases) {
        try {
          const rect = canvas.getBoundingClientRect();
          if (canvas.width === 0 || canvas.height === 0 || rect.width === 0 || rect.height === 0) {
            continue; //跳過尺寸無效的非地圖畫布
          }

          const img = document.createElement("img");
          img.src = canvas.toDataURL("image/png");
          img.width = rect.width;
          img.height = rect.height;
          img.setAttribute("width", rect.width);
          img.setAttribute("height", rect.height);

          img.className = canvas.className;
          if (canvas.id) img.id = canvas.id;
          img.setAttribute("data-replaced-canvas", "true");

          // 設置父容器,取消原本width,height
          const parent = canvas.parentNode;
          const parentOriginalWidth = parent.style.width;
          const parentOriginalHeight = parent.style.height;
          parent.style.width = null;
          parent.style.height = null;

          const originalVisibility = canvas.style.visibility;
          canvas.style.visibility = "hidden";
          parent.insertBefore(img, canvas.nextSibling);
          otherImages.push({
            img,
            canvas,
            parent,
            originalVisibility,
            parentOriginalWidth,
            parentOriginalHeight,
          });
        } catch (error) {
          console.error("非地圖畫布轉換錯誤:", error);
        }
      }

      // checkbox加上checked屬性
      const checkboxes = document.querySelectorAll('input[type="checkbox"]');
      // console.log(`checkboxes`, checkboxes);
          
      checkboxes.forEach((checkbox, index) => {
          if (checkboxes[index]) {
              if (checkbox.checked) {
                  checkboxes[index].setAttribute('checked', 'checked');
              } else {
                  checkboxes[index].removeAttribute('checked');
              }
          }
      });

      // 2. 複製HTML
      const cloneHtml = document.documentElement.cloneNode(true);

      // 3. 刪除指定的 c-sidebar 元素,header元素,downloadReport元素
      const sidebar = cloneHtml.querySelector(".c-sidebar.c-sidebar-dark.c-sidebar-lg-show.c-sidebar-fixed");
      if (sidebar) sidebar.remove();

      cloneHtml.querySelectorAll("header").forEach((header) => header.remove());
      const downloadBtn = cloneHtml.querySelector("#downloadReport");
      if (downloadBtn) downloadBtn.remove();

      // 4.處理克隆中的 canvas 和圖片
      if (mapImg && mapCanvas[0]?.parentNode) {
        const mapParent = cloneHtml.querySelector(".ol-layer");
        if (mapParent) mapParent.innerHTML = mapImg.outerHTML;
      }
      const clonedImages = cloneHtml.querySelectorAll('img[data-replaced-canvas="true"]');
      clonedImages.forEach((img) => {
        const canvasId = img.id;
        const correspondingCanvas = canvasId ? cloneHtml.querySelector(`canvas#${canvasId}`) : null;
        if (correspondingCanvas?.parentNode) {
          correspondingCanvas.parentNode.replaceChild(img, correspondingCanvas);
        }
      });

      // 5. 恢復原始頁面
      otherImages.forEach(({
          img, canvas, parent, originalVisibility, parentOriginalWidth, parentOriginalHeight
        }) => {
          img.remove();
          canvas.style.visibility = originalVisibility || "";
          parent.style.width = parentOriginalWidth || "";
          parent.style.height = parentOriginalHeight || "";
        });

      // 將 vh 轉為 px 的函數(pdf不認得vh,須轉成px)
      const vhToPx = (vh) => (vh * window.innerHeight) / 100;
      const tables = cloneHtml.querySelectorAll('table[style*="height: 10vh"]');
      tables.forEach((table) => {
        table.style.height = `${vhToPx(10)}px`; // 將 10vh 轉為 px
      });

      // 獲取 HTML 內容
      const screenHtmlContent = cloneHtml.outerHTML;
      //console.log(screenHtmlContent)

      return screenHtmlContent;
    },
    mergeMapCanvasAndConvertToImg(canvases, targetWidth) {
      ///合併地圖畫布函數///

      if (!canvases.length) return null;

      //過濾有效畫布並計算最大尺寸
      let maxWidth = 0;
      let maxHeight = 0;
      const validCanvases = Array.from(canvases).filter((canvas) => {
        const rect = canvas.getBoundingClientRect();
        const isValid = canvas.width > 0 && canvas.height > 0 && rect.width > 0 && rect.height > 0;
        if (!isValid) console.warn("Skipping canvas with invalid dimensions:", canvas, rect);
        return isValid;
      });

      if (!validCanvases.length) return null;

      validCanvases.forEach((canvas) => {
        const rect = canvas.getBoundingClientRect();
        maxWidth = Math.max(maxWidth, rect.width);
        maxHeight = Math.max(maxHeight, rect.height);
      });

      //創建臨時畫布
      const tempCanvas = document.createElement("canvas");
      tempCanvas.width = maxWidth;
      tempCanvas.height = maxHeight;
      const ctx = tempCanvas.getContext("2d");

      //繪製有效畫布
      validCanvases.forEach((canvas) => {
        const rect = canvas.getBoundingClientRect();
        ctx.drawImage(canvas, 0, 0, rect.width, rect.height);
      });

      //創建圖片
      const img = document.createElement("img");
      try {
        img.src = tempCanvas.toDataURL("image/png");
      } catch (error) {
        console.error("Canvas to image conversion error:", error);
        return null;
      }

      img.style.width = "100%";
      img.style.height = "auto";
      const targetHeight = Math.round((maxHeight * targetWidth) / maxWidth);
      img.setAttribute("width", targetWidth);
      img.setAttribute("height", targetHeight);

      return img;
    },
    setLockedReport(lockedReport) {
      //console.log(`LockedReport`, lockedReport);
      this.$store.commit("set", ["lockedReport", lockedReport]);
    },
    openSurvey() {
      // 另開視窗打開問卷網址
      window.open('https://forms.office.com/r/7CW9e85g9G', '_blank');
    },
    detectElementResize() {
      const self = this;
      const resizeObserver = new ResizeObserver(entries => {
          for (let entry of entries) {
              // console.log('元素大小改變:', entry.target);
              // console.log('新尺寸:', entry.contentRect);
              self.map.resize();
            }
      });

      // 監控特定元素
      const targetElement =  this.$refs["rpt-result"];
      resizeObserver.observe(targetElement);
    }
  },
  provide() {
    return {
      freeAccountMask,
    };
  },
};
</script>

<style lang="css" scoped>
.download-animate {
  animation: slide-down 2s ease-in-out infinite;
  display: inline-block;
}

@keyframes slide-down {
  0% {
    transform: translateY(-10px);
    opacity: 0.5;
  }

  50% {
    transform: translateY(0);
    opacity: 1;
  }

  100% {
    transform: translateY(10px);
    opacity: 0.5;
  }
}
</style>
